// extracted by mini-css-extract-plugin
export var activeState = "search-module--activeState--yM0do";
export var algoliaSearch = "search-module--algoliaSearch--5dT8u";
export var backCta = "search-module--backCta--ihKvm";
export var cardBox = "search-module--cardBox--eSGC3";
export var cardContent = "search-module--cardContent--qCWA9";
export var cardDetails = "search-module--cardDetails--JvIJV";
export var cardImg = "search-module--cardImg--56Nxb";
export var close = "search-module--close---dNEx";
export var courseFullDetails = "search-module--courseFullDetails--axgzS";
export var courseListInfo = "search-module--courseListInfo--gvuMS";
export var courseName = "search-module--courseName--Ikfer";
export var ctaSection = "search-module--ctaSection--n6rWX";
export var disable = "search-module--disable--CVnYY";
export var displayHits = "search-module--displayHits--FV09f";
export var flexPagination = "search-module--flexPagination--S7SS5";
export var headerSearch = "search-module--headerSearch--TRTJc";
export var heading = "search-module--heading--PQz19";
export var hideOnMobile = "search-module--hideOnMobile--HV7e1";
export var inActiveState = "search-module--inActiveState--BY11x";
export var link = "search-module--link--HjcZg";
export var pageInfoSection = "search-module--pageInfoSection--7YBTf";
export var search = "search-module--search--3SVb-";
export var searchBar = "search-module--searchBar--IMCRD";
export var searchContainer = "search-module--searchContainer---EuP7";
export var searchDetails = "search-module--searchDetails--VoGcw";
export var searchWrapper = "search-module--searchWrapper--aYxw0";
export var shawBtn = "search-module--shawBtn--WVJJc";
export var showOnMobile = "search-module--showOnMobile--bSJRi";
export var totalHits = "search-module--totalHits--o0mF1";